var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"nice-icon",class:[
		_vm.iconClass,
		_vm.iconState
	],attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 100 100"}},[_c('use',{style:({
			'--ni-icon-state': _vm.state,
		}),attrs:{"xlink:href":("#nice_icon--symbol_" + _vm.icon),"x":"0","y":"0","width":"100","height":"100"}})])}
var staticRenderFns = []

export { render, staticRenderFns }